import { usePropertyRentalMoreThan10kExpenditures } from '../../../../queries/PropertyFields/RentalFlagFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components/';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';

interface CapitalExpendituresRentalProps {
    propertyGuid: string;
    label: string;
    required?: boolean;
    isReview?: boolean;
}

export const CapitalExpendituresRental: React.FC<CapitalExpendituresRentalProps> = ({
    propertyGuid,
    label = 'In the first 6 months of ownership are over $20,000 of capital expenditures planned?',
    required = false,
    isReview = false,
}) => {
    const [moreThan10kExpenditures, set_moreThan10kExpenditures] = usePropertyRentalMoreThan10kExpenditures(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        set_moreThan10kExpenditures(e.itemData?.id === 'Yes');
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={moreThan10kExpenditures ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='moreThan10kExpenditures'
                    value={moreThan10kExpenditures}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='This field is required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
